// src/components/ui/ModalManager.jsx

import React from "react";
import { useModal } from "@/contexts/ModalContext";

// Import all your modals here
import SubmissionModal from "@/components/competitions/SubmissionModal";
import EditSubmission from "@/components/forms/EditSubmission";
import CompetitionEntryForm from "@/components/forms/CompetitionEntryForm";
import ForgotPasswordModal from "@/components/auth/ForgotPasswordModal"; // ✅ Add this

/**
 * Renders the active modal according to modalType from ModalContext.
 * Add cases for any new modal types as needed.
 * 
 * 🔧 FIXED: Removed manual prop passing—each modal component now reads from
 * useModal() context directly. This eliminates the need for isOpen/onClose props
 * and makes each modal self-contained.
 */
const ModalManager = () => {
  const { modalType } = useModal();

  switch (modalType) {
    case "SUBMISSION_PREVIEW":
      return <SubmissionModal />;
      
    case "EDIT_SUBMISSION":
      return <EditSubmission />;
      
    case "COMP_ENTRY_FORM":
      return <CompetitionEntryForm />;
      
    case "FORGOT_PASSWORD": // ✅ Add this case
      return <ForgotPasswordModal />;
      
    default:
      return null; // No modal open
  }
};

export default ModalManager;